import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {BookingActions, useBookingContext} from 'src/context/BookingContext';
import {useLocationDetailsContext} from 'src/context/LocationDetailsContext';

import './BookingInitial.scss';
import {LocationForm} from '../../LocationForm/LocationForm';
import {useClinicDetailsContext} from 'src/context/ClinicDetailsContext';
import {fetchUnreserveTimeSlot} from 'src/services/api/api';

export function BookingInitial() {
    const {t} = useTranslation();

    const {
        locationDataState: {location, loading, hasDropin, hasBooking}
    } = useLocationDetailsContext();

    const {dispatch, bookingState} = useBookingContext();

    const {
        dataState: {clinic}
    } = useClinicDetailsContext();

    const [selectionActive, setSelectionActive] = useState(false);

    const bookingType = bookingState.bookingType;

    let locationName = location?.name ?? '';
    let city = '';
    if (location?.city) {
        city = `, ${location.city}`;
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (bookingState.bookingId === null || clinic === null || location === null) {
            return;
        }

        const clearTimeSlot = async () => {
            try {
                if (clinic) {
                    await fetchUnreserveTimeSlot(clinic.id, bookingState.bookingId as string);
                    dispatch({type: BookingActions.CLEAR_BOOKING_ID});
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        };

        clearTimeSlot();
    }, [bookingState.bookingId, location, clinic, dispatch]);

    useEffect(() => {
        if (!location) {
            return;
        }
    }, [location, dispatch]);

    return (
        <main className='main-content main-content--initial' id='main'>
            <section className='main-content__section'>
                {loading && <span className='skeleton-box'></span>}
                {!loading && (
                    <h1 className='main-content__header main-content--initial__header'>{`${locationName}${city}`}</h1>
                )}
            </section>
            <div>
                <nav
                    className={`nav-container ${selectionActive === false ? 'nav-container--no-selection' : ''}`}
                    role='tablist'
                >
                    {hasBooking && (
                        <button
                            onClick={() => {
                                dispatch({type: BookingActions.SET_BOOKING_TYPE, value: 'booking'});
                                setSelectionActive(true);
                            }}
                            type='button'
                            className={`tab-option ${
                                selectionActive && bookingType === 'booking' ? 'selected' : ''
                            } 'booking'`}
                        >
                            <span>{t('clinic_main.booking')}</span>
                        </button>
                    )}
                    {hasDropin && (
                        <button
                            onClick={() => {
                                dispatch({type: BookingActions.SET_BOOKING_TYPE, value: 'dropIn'});
                                setSelectionActive(true);
                            }}
                            type='button'
                            className={`tab-option ${
                                selectionActive && bookingType === 'dropIn' ? 'selected' : ''
                            } 'drop-in'`}
                        >
                            <span>{t('clinic_main.drop_in')}</span>
                        </button>
                    )}
                </nav>
                <LocationForm />
            </div>
        </main>
    );
}
